module.exports = __webpack_public_path__ + "static/img/12.a06977d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/12.png
// module id = Cl1s
// module chunks = 0